import { Divider, IconButton, MenuItem, Typography } from '@material-ui/core';
import Assignment from '@material-ui/icons/Assignment';
import BlurOn from '@material-ui/icons/BlurOn';
import Close from '@material-ui/icons/Close';
import ThumbDownAltOutlined from '@material-ui/icons/ThumbDownAltOutlined';
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined';
import Undo from '@material-ui/icons/Undo';
import ViewList from '@material-ui/icons/ViewList';
import React, { Component } from 'react';

const menuItens = [
  {
    id: 'desfazer',
    color: '#2196f3',
    icon: <Undo />,
    title: 'Desfaz auditoria da guia selecionada',
    text: 'Desfazer',
    dialogTitle: 'Desfazer auditoria da guia',
    dialogMessage: 'Deseja desfazer auditoria de todos os elementos da guia?',
  },
  {
    id: 'automatica',
    color: '#3ec6ff',
    icon: <BlurOn />,
    title: 'Audita automaticamente todos os elementos não auditados da guia selecionada',
    text: 'Audit. Autom.',
    dialogTitle: 'Auditoria automática da guia',
    dialogMessage: 'Deseja executar auditoria automática para todos os elementos não auditados da guia?',
  },
  {
    id: 'autorizar',
    color: '#4caf50',
    icon: <ThumbUpAltOutlined />,
    title: 'Autoriza todos os elementos não auditados da guia selecionada',
    text: 'Autorizar',
    dialogTitle: 'Autorizar guia',
    dialogMessage: 'Deseja autorizar todos os elementos da guia?',
  },
  {
    id: 'glosar',
    color: '#ef5350',
    icon: <ThumbDownAltOutlined />,
    title: 'Nega todos os elementos da guia selecionada',
    text: 'Glosar',
    dialogTitle: 'Glosar guia',
    dialogMessage: 'Deseja glosar todos os elementos da guia?',
  },
];

class MenuListGuia extends Component {
  render () {
    const { loteSelecionado, guia, onClickOperacao, handleClickGuiaOriginal, handleClickGuiasSolicitacao, handleCloseVertMenu } = this.props;

    return (
      <div>
        { menuItens.map((item, idx) =>
          <MenuItem
            key={idx}
            style={{color: item.color}}
            disabled={
              (loteSelecionado.indReapresentacao === 'S' && item.id === 'automatica') ||
                /* { (loteSelecionado.qtdeGuiasJaAuditadas === 0 && item.id === 'desfazer') || } */
                (guia.qtdeElementosJaAuditados === 0 && item.id === 'desfazer') ||
                (guia.qtdeElementosJaAuditados === guia.qtdeElementos && item.id !== 'desfazer')
            }
            onClick={() => onClickOperacao(item.id, `${item.dialogTitle} ${guia.numGuiaPrestador}`, item.dialogMessage)}
          >
            <IconButton style={{color: item.color}} variant='outlined' size='small'>
              {item.icon}
            </IconButton>
            <Typography variant='inherit'>{item.text}</Typography>
          </MenuItem>
        )}
        {
          guia.codGuiaRecorrida
            ? <div>
              <Divider />
              <MenuItem onClick={() => handleClickGuiaOriginal()}>
                <IconButton variant='outlined' size='small'>
                  <Assignment />
                </IconButton>
                <Typography variant='inherit'>Guia original</Typography>
              </MenuItem>
            </div>
            : null
        }
        <div>
          <Divider />
          <MenuItem onClick={() => handleClickGuiasSolicitacao()}>
            <IconButton variant='outlined' size='small'>
              <ViewList />
            </IconButton>
            <Typography variant='inherit'>Guias Solicitação</Typography>
          </MenuItem>
          <Divider />
        </div>
        <MenuItem onClick={handleCloseVertMenu}>
          <IconButton variant='outlined' size='small'>
            <Close />
          </IconButton>
          <Typography variant='inherit'>Fechar</Typography>
        </MenuItem>
      </div>
    );
  }
}

export default MenuListGuia;
